import React from 'react';

/**
 * Captura cualquier error de render en el subárbol y muestra un fallback
 * en vez de una pantalla beige plana sin info.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Para debugging desde DevTools
        console.error('[ErrorBoundary]', error, errorInfo);
    }

    handleReset = () => {
        // Limpia el estado de error sin recargar la página completa
        this.setState({ hasError: false, error: null });
    };

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div
                    className="min-h-screen flex items-center justify-center p-6"
                    style={{ background: 'var(--app-bg)' }}
                    data-testid="error-boundary"
                >
                    <div className="bg-white border border-[#ECE3D2] rounded-2xl p-8 max-w-md w-full text-center shadow-sm">
                        <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-red-50 flex items-center justify-center text-2xl">
                            ⚠️
                        </div>
                        <h2 className="font-display text-xl font-bold text-[#1F2D4B] mb-2">
                            Algo se quedó atorado
                        </h2>
                        <p className="text-sm text-[#4B5878] mb-5">
                            Hubo un error inesperado al cargar esta vista.
                            Intenta continuar o refresca la página si el problema persiste.
                        </p>
                        <div className="space-y-2">
                            <button
                                onClick={this.handleReset}
                                data-testid="error-continue-btn"
                                className="w-full h-11 bg-[#1F2D4B] hover:bg-[#2E3F60] text-white rounded-md text-sm font-semibold transition-colors"
                            >
                                Continuar
                            </button>
                            <button
                                onClick={this.handleReload}
                                data-testid="error-reload-btn"
                                className="w-full h-10 bg-transparent border border-[#ECE3D2] text-[#4B5878] hover:bg-[#FAF6F0] rounded-md text-xs font-medium transition-colors"
                            >
                                Refrescar página
                            </button>
                        </div>
                        {this.state.error && (
                            <details className="mt-4 text-left">
                                <summary className="text-[11px] text-[#8B8474] cursor-pointer">
                                    Ver detalles técnicos
                                </summary>
                                <pre className="text-[10px] text-[#8B8474] mt-2 p-2 bg-[#FAF6F0] rounded overflow-auto max-h-32 whitespace-pre-wrap break-words">
                                    {String(this.state.error?.message || this.state.error)}
                                </pre>
                            </details>
                        )}
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
